import { i18nMark } from 'lingui-react';

const messages = {
  description: i18nMark('Service Request Wizard'),
  title: i18nMark('Service Request Wizard'),
};

export default messages;



// WEBPACK FOOTER //
// ./containers/ServiceRequestCreatePage/messages.js